// extracted by mini-css-extract-plugin
export default {"tickIcon":"Icons__tickIcon___gUYCr"};